import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/check-circle.svg?raw
var t, n = e((() => {
	t = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n  <path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\"></path>\n  <polyline points=\"22 4 12 14.01 9 11.01\"></polyline>\n</svg>\n";
}));
n();
export { t as default, n as init_check_circle };
